import RedirectItem from './RedirectItem'

export default RedirectItem